const APP_STORE_URL = "https://apps.apple.com/us/app/id6798799996";

export default function AppStoreBadge({ size = "md", className = "", href = APP_STORE_URL, testId = "app-store-btn" }) {
  const heightCls = size === "sm" ? "h-10" : size === "lg" ? "h-14" : "h-12";
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid={testId}
      aria-label="Download on the App Store"
      className={`inline-block transition-transform hover:scale-[1.03] active:scale-95 ${className}`}
    >
      <img
        src="/app-store-badge.svg"
        alt="Download on the App Store"
        className={`${heightCls} w-auto`}
        loading="lazy"
      />
    </a>
  );
}
